import { initContract } from '@ts-rest/core'
import { cartBundlesContract } from './bundles.contract'
import { cartCartsContract } from './carts.contract'
import { cartHealthContract } from './healthContract'
import { cartPlansContract } from './plans.contract'
import { cartSubscriptionsContract } from './subscriptions.contract'

const c = initContract()

export const cartServiceContract = c.router(
  {
    carts: cartCartsContract,
    bundles: cartBundlesContract,
    subscriptions: cartSubscriptionsContract,
    plans: cartPlansContract,
    health: cartHealthContract,
  },
)
